import ConfirmModalComponent from "@/components/sharedComponents/confirm/confirm.component";
import { Location } from "@/interfaces/location";
import { WeedMaps } from "@/interfaces/weedMaps";
import { geographicalService } from "@/services/geographical.service";
import { locationsService } from "@/services/locations.service";
import { messagesService } from "@/services/messages.service";
import { weedMapsIntegrationService } from "@/services/weedMapsIntegration.service";
import Cookie from "js-cookie";
import { Component, Vue } from "vue-property-decorator";
import Template from "./WeedMapsIntegration.template.vue";

@Component({
  mixins: [Template],
  components: {}
})
export default class WeedMapsIntegrationComponent extends Vue {
  public loading = false;
  public locations: Location[] = [];
  public data: WeedMaps[] = [];
  public keyData = 0;
  public cookieId = -1;
  public weedmapConnectionData = {};
  public $st(translate: string) {
    return this.$t(`${translate}`);
  }

  public async mounted() {
    await this.getLocations();
  }

  public async beforeMount() {
    this.loading = true;
    this.$emit("onSetLoading", this.loading);
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    this.cookieId = -1;
    if (code) {
      await this.getLocations();
      this.cookieId = Number(Cookie.get("weedmaps_location_id"));
      const token = await weedMapsIntegrationService.weedmapsCode(code);
      const timezoneID = this.locations.find(l => l.id === +this.cookieId)!
        .timezone_id;
      const timezone = await geographicalService.getTimezoneByID(timezoneID!);
      const timezonetoken = (timezone && timezone.zone) || "";
      const createCatalog = await weedMapsIntegrationService.createCatalog(
        token,
        timezonetoken
      );

      const index = this.data.findIndex(
        d => d.biotrack_location_id === +this.cookieId
      );
      if (createCatalog && this.data) {
        if (!this.data[index].is_integration_active) {
          this.data[index].show_message = true;
        }
        this.data[index] = {
          ...this.data[index],
          is_enabled: createCatalog.is_integration_active, // create Catalog.is_integration_active returns weedmaps enabled or disabled
          loading: false
        };
        messagesService.renderSuccessMessage("weedmaps.location_enabled");
        this.keyData = this.data[index].biotrack_location_id;
      }
      this.cookieId = -1;
    }

    this.$router.push("");
    this.loading = false;
    this.$emit("onSetLoading", this.loading);
  }

  public async getLocations(): Promise<void> {
    this.locations = await locationsService.getLocations();
  }

  public async disableIntegration(currentModel: WeedMaps) {
    if (this.loading) {
      return;
    }
    this.loading = true;
    this.$emit("onSetLoading", this.loading);
    await weedMapsIntegrationService.disableIntegration(
      currentModel.biotrack_location_id
    );
    this.loading = false;
    this.$emit("onSetLoading", this.loading);
  }

  public integrateWeedMaps(currentModel: WeedMaps) {
    this.$modals
      .load<boolean>(
        ConfirmModalComponent,
        {
          size: "normal"
        },
        {
          modalData: {
            title: "warning",
            body: "weedmaps.confirmation_integration",
            bodyParams: {
              location: currentModel.biotrack_location_name,
              wmid: currentModel.listing_wmid
            },
            icon: "fal fa-exclamation-triangle"
          }
        }
      )
      .then(
        () => {
          this.enableIntegration(currentModel);
        },
        () => {
          /** Nothing to do */
        }
      );
  }

  public async enableIntegration(currentModel: WeedMaps) {
    if (this.loading) {
      return;
    }
    this.loading = true;
    this.$emit("onSetLoading", this.loading);
    const timezoneID =
      (!currentModel.timezone &&
        this.locations.find(l => l.id === currentModel.biotrack_location_id)!
          .timezone_id) ||
      null;
    const model = {
      ...currentModel,
      listing_wmid: currentModel.listing_wmid,
      timezone:
        currentModel.timezone ||
        (timezoneID && (await this.loadTimezone(timezoneID))) ||
        "",
      biotrack_location_id: currentModel.biotrack_location_id
    };
    weedMapsIntegrationService.enableIntegration(model as WeedMaps);
  }

  public async loadTimezone(idLocation: number) {
    const timezone = await geographicalService.getTimezoneByID(idLocation);
    return (timezone && timezone.zone) || "";
  }

  public async loadStatus() {
    return await weedMapsIntegrationService.checkIntegrationStatus();
  }

  public async connect() {
    this.loading = true;
    try {
      this.weedmapConnectionData = await weedMapsIntegrationService.connect();
    } catch (e) {
      messagesService.renderErrorMessage(e);
    }
  }
}
